import { captureException } from '@sentry/react'
import { useEffect } from 'react'

const SilentFullPageErrorFallback = ({ error }: { error: any }) => {
  useEffect(() => {
    captureException(error)
    setTimeout(() => window.location.reload(), 1500)
  }, [error])

  return (
    <div className="fixed inset-0 bg-surface flex items-center justify-center" />
  )
}

export default SilentFullPageErrorFallback
